import { FC, memo } from 'react';
import NoItemsImage from 'assets/images/no-items.svg';

type EmptyStateForTableProps = {
  mainMessage: string;
  infoMessage: string;
  colspan?: number;
  imageIcon?: string;
};

const EmptyStateForTable: FC<EmptyStateForTableProps> = ({
  mainMessage,
  infoMessage,
  colspan = 9,
  imageIcon = NoItemsImage,
}) => (
  <tbody>
    <tr className="tb-tnx-item">
      <td colSpan={colspan}>
        <div className="nk-help justify-content-center my-4">
          <div className="nk-help-img">
            <img src={imageIcon} alt="imageIcon" />
          </div>

          <div className="nk-help-text flex-grow-0 text-left text-wrap">
            {mainMessage && <h5>{mainMessage}</h5>}
            {infoMessage && <p className="text-soft">{infoMessage}</p>}
          </div>
        </div>
      </td>
    </tr>
  </tbody>
);

export default memo(EmptyStateForTable);
